import { Card, CardHeader, CardTitle, CardBody, Skeleton } from '@vnetwork/ui/primitives';
import { Alert } from '@vnetwork/ui/feedback';
import { InfoGrid, type InfoItem } from '@/pages/account/components/InfoGrid';
import { miscLabel } from './label-maps';
import { useCustomerAddress } from '@/api/customer-basic';

/**
 * Customer address section — read-only display of the customer's postal address
 * from `GET /customers/:id/address`. Country slugs are humanised (`vn` →
 * Vietnam); empty fields render an em dash via `InfoGrid`. Editing the address
 * is deferred (Phase 2b).
 */
export function CustomerAddressSection({ customerId }: { customerId: number }) {
  const { data, isLoading, isError } = useCustomerAddress(customerId);
  const address = data?.result;

  const items: InfoItem[] = [
    { label: 'Country', value: miscLabel(address?.customer_country) ?? address?.customer_country },
    { label: 'Province', value: address?.customer_province },
    { label: 'District', value: address?.customer_district },
    { label: 'Zip Code', value: address?.customer_zipcode },
    { label: 'Address', value: address?.customer_address, full: true },
  ];

  return (
    <Card flat>
      <CardHeader>
        <CardTitle>Address</CardTitle>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <Skeleton variant="text" width="60%" />
        ) : isError ? (
          <Alert tone="danger" title="Failed to load address." />
        ) : (
          <InfoGrid items={items} />
        )}
      </CardBody>
    </Card>
  );
}

export default CustomerAddressSection;
